// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"23948eeb","542":"5f38570b","684":"17242fb3","960":"3f3d93a2","966":"da34735a"}[chunkId] + ".chunk.css";
};